/* eslint-disable camelcase */
export declare class OrderTaskParams {
  user_id: number
  company_id: string
  page: number
  size?: number
  // eslint-disable-next-line no-use-before-define
  stage?: OrderTaskStage
}

export enum OrderTaskStage {
  // 2待处理 3待确认 4已完成
  Task_STAGE_ALL = 1, // all 所有 不包含上报转出
  Task_STAGE_UNDEAL = 2, // 待处理
  Task_STAGE_ING = 3, // 进行中
  Task_STAGE_DONE = 4, // 已完成
  Task_STAGE_UNUSUAL = 5, // 异常
  Task_STAGE_ALLUSUAL = 6, // 正常所有
  Task_STAGE_APPEAR = 7, // 上报
  Task_STAGE_TRANSFER = 8, // 转出单
}
